<template>
    <div v-if="true">
        <table class="table bg-white table-responsive">
            <tbody>
                <tr>
                    <!-- Recursos -->
                    <td v-for="(lista, recurso, irx) in marcacoes_recursos" :key="irx">
                      <table class="table table-sm" style="min-width: 250px;">
                        <thead>
                          <tr>
                            <th colspan="2">
                              <a href="#" class="card-link">
                                {{ recurso }}
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(agenda, iax) in lista" :key="'A' + irx + iax" class="small"> 
                            <td width="10%">
                              <span class="mr-3" >
                                {{ agenda.dt_inicio.slice(11,16) }}
                              </span>
                            </td>
                            <td>
                              <span>
                                {{ agenda.medico.st_nome_exibicao }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>

                    <!-- Médicos -->
                    <td v-for="(agendas, medico, imx) in medicos" :key="'med' + imx">
                        <table class="table table-sm" style="min-width: 250px;">
                            <thead>
                                <tr>
                                    <th colspan="2" v-if="agendas[0] && !agendas[0].coleta_dom">
                                        <a href="#" class="card-link" @click.prevent="selecionar_medico(agendas)">
                                            {{ medico }}
                                        </a>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(lista, titulo, itx) in grupo_titulo(agendas)">
                                    <tr :key="'t' + itx" v-if="true">
                                        <td class="table-secondary" colspan="2">
                                            {{ titulo }}
                                            <div class="progress mb-0" v-if="false">
                                                <div class="progress-bar bg-danger" role="progressbar" :style="'width: ' + perc_status(lista, 'bloqueado') + '%'"></div>
                                                <div class="progress-bar bg-primary" role="progressbar" :style="'width: ' + perc_status(lista, 'livre') + '%'"></div>
                                                <div class="progress-bar bg-success" role="progressbar" :style="'width: ' + perc_status(lista, 'ocupado') + '%'"></div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-for="(agenda, iax) in lista" :key="'A' + itx + iax" class="small"
                                        :class="( cores && proc_marcado(agenda) ) ? 'table-' + cores[proc_marcado(agenda).index] : ''"> 
                                        <td width="10%">
                                          <span class="mr-3" v-if="agenda.hg">
                                            {{ agenda.hg }}
                                          </span>
                                          <span class="mr-3" v-else>
                                            {{ agenda.hora }}
                                          </span>
                                        </td>
                                        <td>
                                            <span v-if="agenda.status == 'ocupado'">

                                                <template v-if="!callback">
                                                  {{ agenda.marcacao.nome_paciente }}
                                                </template>
                                                <template v-else>
                                                  <a href="#" @click.prevent="callback(agenda)" class="card-link">
                                                    {{ agenda.marcacao.nome_paciente }}
                                                  </a>
                                                </template>

                                                <div class="text-muted small">
                                                    <div>{{ agenda.marcacao.procedimento ? agenda.marcacao.procedimento.st_procedimento : '' }}</div>
                                                    <div>
                                                      <i class="fa fa-credit-card-alt fa-fw mr-2" aria-hidden="true" v-if="cc"></i>
                                                      {{ agenda.marcacao.plano ? agenda.marcacao.plano.operadora.search : '' }}
                                                      <span v-if="agenda.unidade_operacao && agenda.unidade_operacao.st_sigla">
                                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                        {{ agenda.unidade_operacao.st_sigla }}
                                                      </span>
                                                    </div>
                                                    <div v-if="agenda.marcacao.fl_extra" class="text-dark">Extra</div>

                                                    <!-- Médico -->
                                                    <div v-if="cc && agenda.marcacao.medico">
                                                      <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                                      {{ agenda.marcacao.medico.st_nome_exibicao }}
                                                    </div>
                                                    <div v-else-if="agenda.marcacao.medico_comp">
                                                      <i class="fa fa-user-md fa-fw mr-2" aria-hidden="true"></i>
                                                      {{ agenda.marcacao.medico_comp.st_nome_exibicao }}
                                                    </div>
                                                    <!-- Fim Médico -->

                                                    <div v-if="agenda.coleta_dom && agenda.st_observacoes" class="text-dark text-truncate">
                                                      {{ agenda.st_observacoes }}
                                                    </div>
                                                    <div v-if="agenda.marcacao && agenda.marcacao.eqps && agenda.marcacao.eqps.length">
                                                      <span class="badge badge-secondary" v-for="(eqp, iex) in agenda.marcacao.eqps" :key="iex">
                                                        {{ eqp.equipamento.st_sigla }}
                                                      </span>
                                                    </div>

                                                    <!-- Região da Coleta Domiciliar -->
                                                    <div v-if="agenda.marcacao && agenda.marcacao.regiao">
                                                      {{ agenda.marcacao.regiao }}
                                                    </div>

                                                    <div v-else-if="agenda.marcacao && agenda.marcacao.regiao_cd">
                                                      {{ agenda.marcacao.regiao_cd.search }}
                                                    </div>
                                                </div>
                                            </span>

                                            <!-- Bloqueio -->
                                            <span v-else-if="agenda.status == 'bloqueado'">
                                              <span  class="badge badge-danger">
                                                  BLOQ
                                              </span>
                                              
                                              <a type="button" class="ml-2" title="Liberar horário" 
                                                v-if="pode_bloquear_horario && agenda.bloqueio && agenda.bloqueio.id_agenda"
                                                href="#"
                                                @click.prevent="bloquear_horario(agenda)"
                                                :disabled="$store.state.loading">
                                                <i class="far fa-circle"></i>
                                              </a>  

                                              <div v-if="agenda.bloqueio.usuario" class="small text-muted ml-2">
                                                Por: {{ agenda.bloqueio.usuario.st_login }}
                                              </div>

                                              <div v-if="agenda.bloqueio.dt_bloqueio" class="small text-muted ml-2">
                                                Em: {{ $util.getFormatDate(agenda.bloqueio.dt_bloqueio, 'DD/MM') }} {{ agenda.bloqueio.dt_bloqueio.slice(11,16) }}
                                              </div>

                                              <a href="#" @click.prevent="set_obs_bloqueio(agenda)" class="small text-muted ml-2">
                                                    <span v-if="agenda.bloqueio.st_observacao">{{ agenda.bloqueio.st_observacao }}</span>
                                                    <span v-else>Observação...</span>
                                              </a>
                                            </span>

                                            <span v-else-if="agenda.status == 'reservado'">
                                                <a href="#" @click.prevent="marcar(agenda)" v-if="( agenda.reserva && agenda.reserva.usuario && agenda.reserva.usuario.id_usuario == $store.state.user.id_usuario )">
                                                    <span class="badge badge-info">
                                                        RESERVADO
                                                    </span>
                                                </a>

                                                <span v-else class="badge badge-danger">
                                                    RESERVADO
                                                </span>
                                              
                                                <a type="button" class="ml-2" title="Liberar horário" 
                                                    v-if="pode_bloquear_horario && agenda.reserva && agenda.reserva.id_reserva_horario"
                                                    href="#"
                                                    @click.prevent="remover_reserva(agenda)"
                                                    :disabled="$store.state.loading">
                                                    <i class="far fa-circle" aria-hidden="true"></i>
                                                </a>  

                                                <div v-if="agenda.reserva.usuario" class="small text-muted ml-2">
                                                    Por: {{ agenda.reserva.usuario.st_login }}
                                                </div>

                                                <div v-if="agenda.reserva.created_at" class="small text-muted ml-2">
                                                    Em: {{ $util.getFormatDate(agenda.reserva.created_at, 'DD/MM') }} {{ agenda.reserva.created_at.slice(11,16) }}
                                                </div>

                                                <div v-if="agenda.reserva.st_obs" class="small text-muted ml-2">
                                                    {{ agenda.reserva.st_obs }}
                                                </div>
                                            </span>
                                            
                                            <span v-else-if="proc_marcado(agenda)">
                                                {{ proc_marcado(agenda).procedimento.search }}
                                            </span>

                                            <span v-else-if="agenda.status == 'indisponivel'" title="Horário indisponível">
                                                <span class="badge badge-secondary">INDISP.</span>
                                                <span v-if="agenda.rc" class="text-muted small ml-2">
                                                  {{ agenda.rc }}
                                                </span>
                                            </span>
                                            
                                            <a href="#" @click.prevent="marcar(agenda)" v-else-if="agenda.status == 'livre'">
                                              <span class="badge badge-primary">
                                                {{ agenda.extra ? 'EXTRA' : 'LIVRE' }}
                                              </span>
                                            </a>

                                            <span v-else-if="agenda.status == 'passado'">
                                            </span>

                                            <span v-else>
                                                {{ agenda.status }}
                                            </span>

                                            <a href="#" @click.prevent="bloquear_horario(agenda)" class="ml-2" title="Bloquear horário" :disabled="$store.state.loading" v-if="agenda.status == 'livre' && pode_bloquear_horario && !agenda.ordem_chegada">
                                              <i class="fa fa-ban text-danger" aria-hidden="true"></i>
                                            </a>

                                            <span v-if="agenda.status == 'livre' && agenda.medico_comp" class="text-muted ml-2">
                                              {{ agenda.medico_comp.st_nome_exibicao.slice(0,12) }}...
                                            </span>
                                            
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <div class="alert alert-info small" style="white-space: pre-wrap;" v-if="instrucao_medico(agendas)">{{ instrucao_medico(agendas) }}</div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Modal Obs Bloqueio -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="obs_bloqueio">
                    <div class="modal-header">
                        <h5 class="modal-title">Observação do Bloqueio</h5>
                        <button type="button" class="close" @click="fechar_modal(modal_name)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info">
                        {{ obs_bloqueio.hora }}
                        </div>

                        <az-input
                        placeholder="Observação..."
                        type="textarea" 
                        rows="3"
                        v-model="obs_bloqueio.bloqueio.st_observacao" />

                        <pre v-if="false">{{ obs_bloqueio }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="bloqueio" :id="obs_bloqueio.bloqueio.id_bloqueio" />
                        <button type="button" class="btn btn-secondary" @click="fechar_modal(modal_name)">Fechar</button>
                        <az-submit @click="atualizar_obs_bloqueio()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            obs_bloqueio: null,
            obs_bloqueio_ref: null, 
            modal_sufixo: "", 
        }
    },

    components: { 
        AzSubmit,
        AzInput,
        AzAuditLogButton,
    },

    props: ['agendas', 'marcacoes', 'cores', 'cc', 'callback', 'pode_bloquear_horario', 'marcacoes_recursos', 'medico_unidades', 'medico', 'viewonly', 'apenas_livres'],

    computed: { 
        modal_name: function() { 
            return 'modalObsBloqueioTabela' + this.modal_sufixo;
        },

        medicos: function() { 

            return _.groupBy(
                _.orderBy(this.apenas_livres ? this.agendas.filter(item => item.status == 'livre') : this.agendas, 
                item => { 
                    if ( item.coleta_dom ) { 
                        return item.titulo;
                    }

                    if ( this.medico && item.medico && item.medico.id_pessoa == this.medico ) { 
                      return item.data;
                    }

                    const sala = ( item.medico 
                        ? ( item.medico.cc ? item.local_nome : '' ) 
                        : ( _.get(item, 'marcacao.medico.cc') ? item.local_nome : '' ) 
                       );

                    if ( sala )
                      return sala;

                    return item.medico ? item.medico.st_nome_exibicao : _.get(item, 'marcacao.medico.st_nome_exibicao');
                }), 
                item => { 
                  if ( item.coleta_dom ) { 
                    return item.titulo;
                  }

                  if ( this.medico && item.medico && item.medico.id_pessoa == this.medico ) { 
                    return this.$util.getFormatDate(item.data);
                  }

                  const sala = ( item.medico 
                        ? ( item.medico.cc ? item.local_nome : '' ) 
                        : ( _.get(item, 'marcacao.medico.cc') ? item.local_nome : '' ) 
                       );

                  if ( sala ) { 
                    return sala;
                  }

                  return ( item.medico 
                    ? item.medico.st_nome_exibicao 
                    : _.get(item, 'marcacao.medico.st_nome_exibicao') ) ;
                }
            );
        },

        lista_horarios: function() { 
            return _.groupBy(this.agendas, item => item.hora);
        }
    },

    mounted() { 
        this.modal_sufixo = this.$util.uuidv4(); 
    },

    methods: { 
        fechar_modal (nome) { 
            $('#' + nome).modal('hide');
        },
        
        atualizar_obs_bloqueio () { 
            this.$util.atualizar(this, { 
                service: 'bloqueios',
                func: 'store',
                dados: { 
                    ...this.obs_bloqueio.bloqueio,
                    mais_30_dias: this.obs_bloqueio.bloqueio.dt_termino, 
                },
                modal: this.modal_name,
                toast: true, 
                callback: (res) => { 
                    this.obs_bloqueio_ref.bloqueio.st_observacao = res.st_observacao;
                },
            });
        },
        set_obs_bloqueio (hor) { 
            this.obs_bloqueio = _.cloneDeep(hor);
            this.obs_bloqueio_ref = hor;

            $('#' + this.modal_name).modal('show');
        },

        remover_reserva (hor) { 
            $('[data-toggle="tooltip"]').tooltip('dispose');

            if ( !confirm ('Confirma remover a reserva?') ) 
                return; 

            this.$util.remover (this, { 
                service: 'reserva_horarios',
                dados: { 
                    id_reserva_horario: hor.reserva.id_reserva_horario,
                },
                reload: true, 
            });
            
        },

        instrucao_medico (agendas) { 
          return _.get(this.medico_unidades, _.get(agendas, '0.medico.id_pessoa') + '.st_instrucao');
        },

        bloquear_horario (agenda) { 
          if ( this.$store.state.loading )
            return;
          
          this.$emit('bloquearhorario', agenda);
        },

        proc_marcado (agenda) { 
            if ( !this.marcacoes || !agenda )
                return;

            return this.marcacoes.find(item => item.id_agenda == agenda.id_agenda && item.hora == agenda.hora);
        },

        selecionar_medico(agendas) { 
            console.log('md', _.get(agendas, '0.medico'));
        },

        perc_status(lista, status) { 
            if ( lista.length ) { 
                return Math.round( ( lista.filter(item => item.status == status).length / lista.length ) * 100 );
            }
        },

        marcar (agenda) { 
            
            if ( agenda.status == 'livre' || ( agenda.status == 'reservado' && _.get(agenda, 'reserva.usuario.id_usuario') == this.$store.state.user.id_usuario ) ) { 

                if ( this.viewonly ) { 
                    this.$toast.add({
                        severity: "warn",
                        summary: "Atenção",
                        detail: "A edição não está disponível.",
                        life: 5000
                    });
                    return;
                }

                this.$parent.verMarcar(agenda);

            } else { 

                alert('Horário: ' + agenda.status);

            }

        },

        agenda_do_horario(horarios, medico) { 
            return _.filter(horarios, hor => hor.medico.st_nome_exibicao == medico);
        },

        grupo_titulo(horarios) {
            return _.groupBy(horarios, item => item.titulo ? item.titulo : 'Horários');
        }
    }
}
</script>

<style scoped>
/* Cores Extra */

.text-vermelho { 
  color: #900;  
}

.badge-vermelho { 
  background-color: #900;  
  color: white;
}

.btn-vermelho { 
  background-color: #900;  
  color: white;
}

.btn-outline-vermelho { 
  border-color: #900;
  color: #900;
}

.list-group-item-vermelho { 
  background-color: #90000050;
}

/* Rosa */

.text-rosa { 
  color: #e83e8c;  
}

.badge-rosa { 
  background-color: #e83e8c;  
  color: white;
}

.btn-rosa { 
  background-color: #e83e8c;  
  color: white;
}

.btn-outline-rosa { 
  border-color: #e83e8c;
  color: #e83e8c;
}

.list-group-item-rosa { 
  background-color: #e83e8c50;
}

/* Teal */

.text-teal { 
  color: #20c997;  
}

.badge-teal { 
  background-color: #20c997;  
  color: white;
}

.btn-teal { 
  background-color: #20c997;  
  color: white;
}

.btn-outline-teal { 
  border-color: #20c997;
  color: #20c997;
}

.list-group-item-teal { 
  background-color: #20c99750;
}

/* Purple */

.text-purple { 
  color: #6f42c1;  
}

.badge-purple { 
  background-color: #6f42c1;  
  color: white;
}

.btn-purple { 
  background-color: #6f42c1;  
  color: white;
}

.btn-outline-purple { 
  border-color: #6f42c1;
  color: #6f42c1;
}

.list-group-item-purple { 
  background-color: #6f42c150;
}

/* Orange */

.text-orange { 
  color: #fd7e14;  
}

.badge-orange { 
  background-color: #fd7e14;  
  color: white;
}

.btn-orange { 
  background-color: #fd7e14;  
  color: white;
}

.btn-outline-orange { 
  border-color: #fd7e14;
  color: #fd7e14;
}

.list-group-item-orange { 
  background-color: #fd7e1450;
}

/* Orange */

.text-verde-escuro { 
  color: #405d27;  
}

.badge-verde-escuro { 
  background-color: #405d27;  
  color: white;
}

.btn-verde-escuro { 
  background-color: #405d27;  
  color: white;
}

.btn-outline-verde-escuro { 
  border-color: #405d27;
  color: #405d27;
}

.list-group-item-verde-escuro { 
  background-color: #405d2750;
}
</style>